import '@web/shared-digital-library/icons/svg-originals/cross.svg';
export default {
  name: 'CloseButton'
};